import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import { formatDate } from '../../../utils/format';
import { Link } from 'react-router';

@i18n
class Transactions extends Component {
  render() {
    const { list } = this.props;
    return list.length ? (
      <Table condensed responsive>
        <thead>
          <tr>
            <th>{this.i18n('Date')}</th>
            <th>{this.i18n('Order no.')}</th>
          </tr>
        </thead>
        <tbody>
          {list.map(item => (
            <tr key={item.orderno || item.id}>
              <td>{formatDate(item.timestamp)}</td>
              <td>
                <Link to={`/profile/invoice/${item.id}`}>
                  {item.orderno || item.id}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : null;
  }
}

export default Transactions;
